import PropTypes from 'prop-types';
import React from 'react';
import OrientationScale from 'components/OrientationScale';
import PhoenixChart from './PhoenixChart/PhoenixChart';
import FillScale from 'components/FillScale';
import {connect} from 'react-redux';
import {selectIsChartPickerActive} from 'state/cardDetail/cardDetailSelectors';
import {
  disableChartPicker,
  loadFeatures,
} from 'state/cardDetail/cardDetailActions';
import {selectIsFull} from 'state/environment/environmentSelectors';
import DateAnnotationsModal from 'components/DateAnnotationsModal';
import './PhoenixChartDetails.css';

class PhoenixChartDetails extends React.Component {
  state = {
    isDateAnnotationModalOpen: false,
    dateAnnotations: [],
  };

  handleLoad = features => {
    this.props.loadFeatures(this.props.cardId, features);
  };

  handleDisplayAnnotation = data => {
    this.setState({
      isDateAnnotationModalOpen: true,
      dateAnnotations: data.annotations,
    });
  };

  handleRequestModalClose = () => {
    this.setState({
      isDateAnnotationModalOpen: false,
    });
  };

  render() {
    const {
      filters,
      functionOverrides,
      filterGroupIds,
      cardId,
      isFull,
      isChartPickerActive,
      dateTimeElement,
      dateRangeFilter,
      onDrill,
    } = this.props;
    const CardScale = isFull ? OrientationScale : FillScale;

    return (
      <div className="PhoenixChartDetails__Chart">
        <CardScale>
          {(width, height, hasComputed) =>
            hasComputed ? (
              <PhoenixChart
                dateRangeFilter={dateRangeFilter}
                dateTimeElement={dateTimeElement}
                filterGroupIds={filterGroupIds}
                filters={filters}
                functionOverrides={functionOverrides}
                height={height}
                isPicker={isChartPickerActive}
                onDrill={onDrill}
                onLoad={this.handleLoad}
                onRequestChartPickerClose={this.props.disableChartPicker}
                onDisplayAnnotation={this.handleDisplayAnnotation}
                urn={cardId}
                width={width}
              />
            ) : null
          }
        </CardScale>
        <DateAnnotationsModal
          isOpen={this.state.isDateAnnotationModalOpen}
          onRequestModalClose={this.handleRequestModalClose}
          dateAnnotations={this.state.dateAnnotations}
        />
      </div>
    );
  }
}

PhoenixChartDetails.propTypes = {
  cardId: PropTypes.string.isRequired,
  pageId: PropTypes.string,
  filters: PropTypes.array.isRequired,
  functionOverrides: PropTypes.object,
  filterGroupIds: PropTypes.array.isRequired,
  dateTimeElement: PropTypes.string,
  dateRangeFilter: PropTypes.object,
  onDrill: PropTypes.func.isRequired,
};

PhoenixChartDetails.defaultProps = {
  filters: [],
};

export default connect(
  state => ({
    isFull: selectIsFull(state),
    isChartPickerActive: selectIsChartPickerActive(state),
  }),
  {
    disableChartPicker,
    loadFeatures,
  }
)(PhoenixChartDetails);
